import React, { useEffect, useState } from "react";
import useWindowSize from "react-use/lib/useWindowSize";
import Confetti from "react-confetti";

const ConfettiWrapper = () => {
  const { width, height } = useWindowSize();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShow(true);
    }, 10000);
    return () => window.clearTimeout(timer);
  }, []);
  if (!show) {
    return null;
  }
  return <Confetti width={width} height={height} />;
};

export default ConfettiWrapper;
